<script lang="ts">
	import MainLayout from 'src/routes/MainLayout.svelte';
	import MainLayoutNew from 'src/routes/MainLayoutNew.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
</script>

<svelte:component this={$showNewLayout ? MainLayoutNew : MainLayout} />
